/* eslint-disable max-len */
import { AllieColors } from '../../../common/color.types';
import { SVGProps } from 'react';

interface Star06IconProps extends SVGProps<SVGSVGElement> {
  allieColor?: AllieColors;
}

export const Star06Icon: React.FC<Star06IconProps> = ({
  allieColor = 'secondary-50',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M8.66634 2.50065L9.82246 5.50656C10.0105 5.99538 10.1045 6.23979 10.2507 6.44538C10.3802 6.62758 10.5394 6.78678 10.7216 6.91634C10.9272 7.06252 11.1716 7.15652 11.6604 7.34453L14.6663 8.50065L11.6604 9.65677C11.1716 9.84478 10.9272 9.93878 10.7216 10.085C10.5394 10.2145 10.3802 10.3737 10.2507 10.5559C10.1045 10.7615 10.0105 11.0059 9.82246 11.4947L8.66634 14.5007L7.51022 11.4947C7.32222 11.0059 7.22821 10.7615 7.08203 10.5559C6.95247 10.3737 6.79327 10.2145 6.61107 10.085C6.40548 9.93878 6.16107 9.84478 5.67225 9.65677L2.66634 8.50065L5.67225 7.34453C6.16107 7.15652 6.40548 7.06252 6.61106 6.91634C6.79327 6.78678 6.95247 6.62758 7.08203 6.44537C7.22821 6.23979 7.32221 5.99538 7.51022 5.50656L8.66634 2.50065Z"
      fill={`var(--allie-color-${allieColor})`}
    />
    <path
      d="M2.99967 15.1673V11.834M2.99967 5.16732V1.83398M1.33301 3.50065H4.66634M1.33301 13.5007H4.66634M8.66634 2.50065L7.51022 5.50656C7.32221 5.99538 7.22821 6.23979 7.08203 6.44537C6.95247 6.62758 6.79327 6.78678 6.61106 6.91634C6.40548 7.06252 6.16107 7.15652 5.67225 7.34453L2.66634 8.50065L5.67225 9.65677C6.16107 9.84478 6.40548 9.93878 6.61107 10.085C6.79327 10.2145 6.95247 10.3737 7.08203 10.5559C7.22821 10.7615 7.32221 11.0059 7.51022 11.4947L8.66634 14.5007L9.82246 11.4947C10.0105 11.0059 10.1045 10.7615 10.2507 10.5559C10.3802 10.3737 10.5394 10.2145 10.7216 10.085C10.9272 9.93878 11.1716 9.84478 11.6604 9.65677L14.6663 8.50065L11.6604 7.34453C11.1716 7.15652 10.9272 7.06252 10.7216 6.91634C10.5394 6.78678 10.3802 6.62758 10.2507 6.44538C10.1045 6.23979 10.0105 5.99538 9.82246 5.50656L8.66634 2.50065Z"
      stroke={`var(--allie-color-${allieColor})`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
